import { SITE_URL } from '../config.js';

export const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": ["LocalBusiness", "ProfessionalService"],
  "@id": `${SITE_URL}/#business`,
  "name": "FocusMode",
  "alternateName": "פוקוס מוד",
  "description": "פיתוח אתרים עם AI, דפי נחיתה, אוטומציות וחיבורי מערכות לעסקים בישראל.",
  "url": SITE_URL,
  "telephone": "+972524106717",
  "email": "yoav@focusmode.info",
  "image": `${SITE_URL}/og/default.png`,
  "logo": `${SITE_URL}/favicon.svg`,
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "גבעת השלושה",
    "addressCountry": "IL"
  },
  "areaServed": { "@type": "Country", "name": "Israel" },
  "founder": { "@type": "Person", "name": "יואב רון" },
  "sameAs": [
    "https://wa.me/972524106717"
  ]
};

export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "@id": `${SITE_URL}/#org`,
  "name": "FocusMode",
  "url": SITE_URL,
  "logo": `${SITE_URL}/favicon.svg`,
  "founder": { "@type": "Person", "name": "יואב רון" },
  "contactPoint": {
    "@type": "ContactPoint",
    "telephone": "+972524106717",
    "contactType": "customer service",
    "areaServed": "IL",
    "availableLanguage": ["Hebrew", "he"]
  }
};

export function buildFaqSchema(faq) {
  if (!faq || !faq.length) return null;
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faq.map(f => ({
      "@type": "Question",
      "name": f.q,
      "acceptedAnswer": { "@type": "Answer", "text": f.a }
    }))
  };
}

export function buildServiceSchema({ title, slug, description }) {
  return {
    "@context": "https://schema.org",
    "@type": "Service",
    "@id": `${SITE_URL}/services/${slug}#service`,
    "serviceType": title,
    "name": title,
    "description": description || title,
    "url": `${SITE_URL}/services/${slug}`,
    "provider": { "@id": `${SITE_URL}/#business` },
    "areaServed": { "@type": "Country", "name": "Israel" }
  };
}

export function buildArticleSchema(post) {
  if (!post) return null;
  return {
    "@context": "https://schema.org",
    "@type": "Article",
    "@id": `${SITE_URL}/blog/${post.slug}#article`,
    "headline": post.title,
    "description": post.excerpt || post.description || post.title,
    "image": post.image ? (post.image.startsWith('http') ? post.image : `${SITE_URL}${post.image}`) : `${SITE_URL}/og/default.png`,
    "datePublished": post.publishedAt || post.date,
    "dateModified": post.updatedAt || post.publishedAt || post.date,
    "author": {
      "@type": "Person",
      "name": post.author || "יואב רון",
      "url": `${SITE_URL}/about`
    },
    "publisher": { "@id": `${SITE_URL}/#org` },
    "mainEntityOfPage": `${SITE_URL}/blog/${post.slug}`,
    "inLanguage": "he-IL"
  };
}

export function buildItemListSchema(items, listName) {
  if (!items || !items.length) return null;
  return {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "name": listName,
    "itemListElement": items.map((item, idx) => ({
      "@type": "ListItem",
      "position": idx + 1,
      "name": item.name,
      "url": item.url.startsWith('http') ? item.url : `${SITE_URL}${item.url}`
    }))
  };
}

export function buildBreadcrumbSchema(trail) {
  if (!trail || !trail.length) return null;
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": trail.map((item, idx) => ({
      "@type": "ListItem",
      "position": idx + 1,
      "name": item.name,
      "item": item.url.startsWith('http') ? item.url : `${SITE_URL}${item.url}`
    }))
  };
}
